import { Utilities } from '@socrates/common';
import { Version } from './Version';

export class Versions {
	private _versionsMap: Map<string, Version> = new Map<string, Version>();

	private _serverVersion: Version;
	private _appVersion: Version;

	constructor(appVersion: Version, serverVersion?: Version) {
		this._appVersion = appVersion;
		this._serverVersion = serverVersion ?? null;
		this._versionsMap.set(appVersion.name, appVersion);
		if (serverVersion) {
			this._versionsMap.set(serverVersion.name, serverVersion);
		}
	}

	public get versions(): Map<string, Version> {
		return this._versionsMap;
	}

	public get serverVersion(): Version {
		return this._serverVersion;
	}

	get appVersion(): Version {
		return this._appVersion;
	}

	GreaterThanAppVersion(testVersion: string): boolean {
		let eVero = false;

		if (testVersion && Utilities.versionCompare(testVersion, this._appVersion.version) < 0) {
			eVero = true;
		}
		return eVero;
	}

	EqualToAppVersion(testVersion: string): boolean {
		let eVero = false;

		if (testVersion && !this.appVersion.hasError() && Utilities.versionCompare(testVersion, this.appVersion.version) === 0) {
			eVero = true;
		}
		return eVero;
	}

	LessThanAppVersion(testVersion: string): boolean {
		let eVero = false;

		if (testVersion && !this.appVersion.hasError() && Utilities.versionCompare(testVersion, this.appVersion.version) > 0) {
			eVero = true;
		}
		return eVero;
	}

	GreaterThanServerVersion(testVersion: string): boolean {
		let eVero = false;

		if (testVersion && !this.serverVersion?.hasError() && Utilities.versionCompare(testVersion, this.serverVersion.version) < 0) {
			eVero = true;
		}
		return eVero;
	}

	EqualToServerVersion(testVersion: string): boolean {
		let eVero = false;

		if (testVersion && !this.serverVersion?.hasError() && Utilities.versionCompare(testVersion, this.serverVersion.version) === 0) {
			eVero = true;
		}
		return eVero;
	}

	LessThanServerVersion(testVersion: string): boolean {
		let eVero = false;

		if (testVersion && !this.serverVersion?.hasError() && Utilities.versionCompare(testVersion, this.serverVersion.version) > 0) {
			eVero = true;
		}
		return eVero;
	}
}
